import React from 'react';
import i18next from 'i18next';
import {
  findValueById, If, toMoney, trEnv, findBaustein, toMoneyWOComma, Angaben,
} from 'ion-lib';
import { istHausrat } from '../helper';

const Versicherungspaket = (
  daten,
  gotoPage = () => {},
) => {
  const versAuswahl = findBaustein(daten.bausteine, daten.auswahlBaustein);
  const sbVertrag = findValueById(versAuswahl.selbstbeteiligung.valueSet, versAuswahl.selbstbeteiligung.value)
    .replace('.', '')
    .replace('EUR', '')
    .trim();
  const sbElementar = sbVertrag > versAuswahl.selbstbehaltElementar.value ? sbVertrag : versAuswahl.selbstbehaltElementar.value;

  return [
    {
      id: 'versicherungsumfang',
      visible: true,
      header: 'Gewählter Versicherungsumfang',
      content: (
        <div className="content-table">
          <Angaben
            label="Ihr gewählter Tarif"
            auswahl={versAuswahl.label.value}
          />

          <If predicate={versAuswahl.glasversicherung.value && istHausrat()}>
            <Angaben
              label="Beitrag Hausrat"
              auswahl={`${toMoney(versAuswahl.bruttoBeitragHausrat.value)} ${findValueById(daten.zahlweise.valueSet, daten.zahlweise.value)}`}
            />

            <Angaben
              label="Beitrag Glas"
              auswahl={`${toMoney(versAuswahl.bruttoBeitragGlas.value)} ${findValueById(daten.zahlweise.valueSet, daten.zahlweise.value)}`}
            />
          </If>

          <If predicate={!versAuswahl.glasversicherung.value}>
            <Angaben
              label="Ihr Beitrag"
              auswahl={`${toMoney(versAuswahl.bruttoBeitrag.value)} ${findValueById(daten.zahlweise.valueSet, daten.zahlweise.value)}`}
            />
          </If>

          <If predicate={!istHausrat()}>
            <Angaben
              label="Ihr Beitrag"
              auswahl={`${toMoney(versAuswahl.bruttoBeitragGlas.value)} ${findValueById(daten.zahlweise.valueSet, daten.zahlweise.value)}`}
            />
          </If>

          <If predicate={versAuswahl.nberabattWert.relevant}>
            <Angaben
              label="Ihr rabattierter Beitrag"
              auswahl={`${toMoney(versAuswahl.nberabattWert.value)} ${findValueById(daten.zahlweise.valueSet, daten.zahlweise.value)}`}
            />
          </If>

          <If predicate={daten.versSumme.relevant}>
            <Angaben
              label="Versicherungssumme"
              auswahl={toMoneyWOComma(daten.versSumme.value)}
            />
          </If>

          <If predicate={versAuswahl.wertsachenSumme.relevant}>
            <Angaben
              label="Wertsachen bis"
              auswahl={toMoneyWOComma(versAuswahl.wertsachenSumme.value)}
            />
          </If>

          <If predicate={versAuswahl.naturgefahren.relevant}>
            <Angaben
              label="Schutz vor Naturgefahren"
              auswahl={versAuswahl.naturgefahren.value ? 'Ja' : 'Nein'}
            />
          </If>

          <If predicate={versAuswahl.selbstbehaltElementar.relevant}>
            <Angaben
              label={i18next.t('produktvergleich.zusatz.naturgefahren_sb_label')}
              auswahl={toMoneyWOComma(sbElementar)}
            />
          </If>

          <If predicate={versAuswahl.glasversicherung.relevant}>
            <Angaben
              label="Glasversicherung"
              auswahl={versAuswahl.glasversicherung.value ? 'Ja' : 'Nein'}
            />
          </If>

          <If predicate={versAuswahl.notfalldienste.relevant}>
            <Angaben
              label={`${i18next.t('produktvergleich.zusatz.notfalldienste')}`}
              auswahl={versAuswahl.notfalldienste.value ? 'Ja' : 'Nein'}
            />
          </If>

          <If predicate={versAuswahl.fahrraddiebstahl.relevant}>
            <Angaben
              label={`${i18next.t('summingup.fahrrad')}`}
              auswahl={versAuswahl.fahrraddiebstahl.value ? 'Ja' : 'Nein'}
            />
          </If>

          <If predicate={daten.florianrabatt.relevant}>
            <Angaben
              label="Florianrabatt"
              auswahl={daten.florianrabatt.value ? 'Ja' : 'Nein'}
            />
          </If>

          <If predicate={versAuswahl.selbstbeteiligung.relevant}>
            <Angaben
              label="Selbstbeteiligung"
              auswahl={findValueById(versAuswahl.selbstbeteiligung.valueSet, versAuswahl.selbstbeteiligung.value).replace('EUR', '€')}
            />
          </If>

          <Angaben
            label="Vertragslaufzeit"
            auswahl={findValueById(daten.laufzeit.valueSet, daten.laufzeit.value)}
          />

          <Angaben
            label="Versicherungs&shy;beginn"
            auswahl={daten.versBeginn.value}
          />
        </div>
      ),
      edit: () => gotoPage('Produktvergleich'),
      isExpanded: true,
    },
    {
      id: 'vnDaten',
      visible: true,
      header: 'Persönliche Daten',
      content:
      (
        <div className="content-table content-table--flex">
          <Angaben
            label="Anrede"
            auswahl={findValueById(daten.vn.anrede.valueSet, daten.vn.anrede.value)}
          />
          <If predicate={findValueById(daten.vn.titel.valueSet, daten.vn.titel.value)}>
            <Angaben
              label="Titel"
              auswahl={findValueById(daten.vn.titel.valueSet, daten.vn.titel.value)}
            />
          </If>
          <Angaben
            label="Vorname"
            auswahl={daten.vn.vorname.value}
          />
          <Angaben
            label="Nachname"
            auswahl={daten.vn.nachname.value}
          />
          <Angaben
            label="Geburtsdatum"
            auswahl={daten.vn.geburtsdatum.value}
          />
          <Angaben
            label="Straße"
            auswahl={`${daten.vn.strasse.value} ${daten.vn.hausnummer.value}`}
          />
          <Angaben
            label="PLZ, Ort"
            auswahl={`${daten.vn.postleitzahl.value} ${daten.vn.ort.value}`}
          />
          <If predicate={daten.vn.zustellvermerk.value}>
            <Angaben
              label="Zustellvermerk"
              auswahl={`${daten.vn.zustellvermerk.value}`}
            />
          </If>

          <If predicate={daten.vn.email.relevant}>
            <Angaben
              label="E-Mail"
              auswahl={daten.vn.email.value}
            />
          </If>

          <If predicate={daten.vn.telefonNummer.value}>
            <Angaben
              label="Telefonnummer"
              auswahl={daten.vn.telefonNummer.value}
            />
          </If>

        </div>
      ),
      edit: daten.vn.vorname.ueberschreibbar ? () => gotoPage('Personendaten') : false,
    },
    {
      id: 'wagnis',
      visible: true,
      header: 'Objekt',
      content:
        (
          <div className="content-table content-table--flex">

            <If predicate={daten.wagnis.typ.relevant}>
              <Angaben
                label="Objekt"
                auswahl={findValueById(daten.wagnis.typ.valueSet, daten.wagnis.typ.value)}
              />
            </If>
            <If predicate={daten.wagnis.wohnflaeche.relevant}>
              <Angaben
                label="Wohnfläche"
                auswahl={`${daten.wagnis.wohnflaeche.value} m²`}
              />
            </If>

            <Angaben
              label="Straße"
              auswahl={`${daten.wagnis.strasse.value} ${daten.wagnis.hnr.value}`}
            />

            <Angaben
              label="PLZ, Ort"
              auswahl={`${daten.wagnis.plz.value} ${daten.wagnis.ort.value}`}
            />
          </div>
        ),
      edit: () => gotoPage('ErsteDaten'),
    },
    {
      id: 'vorversicherung',
      visible: true,
      header: 'Angaben zur Vorversicherung',
      content:
      (
        <div className="content-table content-table--flex">
          <If predicate={daten.vorversicherung.auswahl.relevant}>
            <Angaben
              label="Bestehende Hausratsversicherung"
              auswahl={findValueById(daten.vorversicherung.auswahl.valueSet, daten.vorversicherung.auswahl.value)}
            />
          </If>

          <If predicate={daten.vorversicherung.name.relevant}>
            <Angaben
              label="Hausratversicherer"
              auswahl={daten.vorversicherung.name.value}
            />
          </If>

          <If predicate={daten.vorversicherung.vsnr.relevant}>
            <Angaben
              label="Versicherungs&shy;scheinnummer"
              auswahl={daten.vorversicherung.vsnr.value && (
              <div
                className="truncate"
                title={daten.vorversicherung.vsnr.value}
              >
                {daten.vorversicherung.vsnr.value}
              </div>
              )}
            />
          </If>

          <If predicate={daten.vorversicherung.gekuendigt.relevant}>
            <Angaben
              label="Vorversicherung gekündigt"
              auswahl={findValueById(daten.vorversicherung.gekuendigt.valueSet, daten.vorversicherung.gekuendigt.value)}
            />
          </If>

          <If predicate={daten.vorversicherung.schaeden.relevant}>
            <Angaben
              label="Vorschäden"
              auswahl={findValueById(
                daten.vorversicherung.schaeden.valueSet,
                daten.vorversicherung.schaeden.value,
              )}
            />
          </If>

          <If predicate={daten.vorversicherungNatur.schaeden.relevant}>
            <Angaben
              label="Elementarschäden"
              auswahl={findValueById(
                daten.vorversicherungNatur.schaeden.valueSet,
                daten.vorversicherungNatur.schaeden.value,
              )}
            />
          </If>

          <If predicate={daten.vorversicherungNatur.schadensursache.relevant}>
            <Angaben
              label="Schadensursache"
              auswahl={findValueById(
                daten.vorversicherungNatur.schadensursache.valueSet,
                daten.vorversicherungNatur.schadensursache.value,
              )}
            />
          </If>

          <If predicate={daten.vorversicherungNatur.rueckstausicherung.relevant}>
            <Angaben
              label="Rückstausicherungen"
              auswahl={findValueById(
                daten.vorversicherungNatur.rueckstausicherung.valueSet,
                daten.vorversicherungNatur.rueckstausicherung.value,
              )}
            />
          </If>

          <If predicate={daten.vorversicherungGlas.auswahl.relevant}>
            <Angaben
              label="Bestehende Glasversicherung"
              auswahl={findValueById(daten.vorversicherungGlas.auswahl.valueSet, daten.vorversicherungGlas.auswahl.value)}
            />
          </If>

          <If predicate={daten.vorversicherungGlas.name.relevant}>
            <Angaben
              label="Glasversicherer"
              auswahl={daten.vorversicherungGlas.name.value}
            />
          </If>

          <If predicate={daten.vorversicherungGlas.vsnr.relevant}>
            <Angaben
              label="Versicherungs&shy;scheinnummer"
              auswahl={daten.vorversicherungGlas.vsnr.value && (
                <div
                  className="truncate"
                  title={daten.vorversicherungGlas.vsnr.value}
                >
                  {daten.vorversicherungGlas.vsnr.value}
                </div>
              )}
            />
          </If>

          <If predicate={daten.vorversicherungGlas.gekuendigt.relevant}>
            <Angaben
              label="Vorversicherung gekündigt"
              auswahl={findValueById(daten.vorversicherungGlas.gekuendigt.valueSet, daten.vorversicherungGlas.gekuendigt.value)}
            />
          </If>

          <If predicate={daten.vorversicherungGlas.schaeden.relevant}>
            <Angaben
              label="Vorschäden"
              auswahl={findValueById(
                daten.vorversicherungGlas.schaeden.valueSet,
                daten.vorversicherungGlas.schaeden.value,
              )}
            />
          </If>
        </div>
      ),
      edit: () => gotoPage('Vorversicherung'),
    },
    {
      id: 'bezahlverfahren',
      visible: true,
      header: 'Zahlungsdaten',
      content:
      (
        <div className="content-table content-table--flex">
          <If predicate={parseInt(daten.bankVerbindung.zahlart.value, 10) !== 0}>
            <Angaben
              label="Kontoinhaber"
              auswahl={daten.bankVerbindung.inhaber.value}
            />

            <Angaben
              label="IBAN"
              auswahl={daten.bankVerbindung.iban.value}
            />

            <p className="text--small" dangerouslySetInnerHTML={{ __html: i18next.t('sepa.text') }} />
          </If>
          <If predicate={parseInt(daten.bankVerbindung.zahlart.value, 10) === 0}>
            <Angaben
              label="Rechnungsempfänger"
              auswahl={daten.bankVerbindung.inhaber.value}
            />

            <Angaben
              label="Straße"
              auswahl={`${daten.vn.strasse.value} ${daten.vn.hausnummer.value}`}
            />

            <Angaben
              label="PLZ, Ort"
              auswahl={`${daten.vn.postleitzahl.value}, ${daten.vn.ort.value}`}
            />
          </If>
        </div>
      ),
      edit: () => gotoPage('Zahlungsdaten'),
    },
    {
      id: 'weitereErklaerungen',
      visible: true,
      header: 'Weitere Erklärungen',
      content: (
        <div className="angaben">
          <If predicate={!trEnv.stationaer}>
            <h4>Beratungsverzicht</h4>
            <p className="text--small">
              Sie möchten online abschließen und verzichten auf eine persönliche Beratung und deren Dokumentation. Das kann sich nachteilig auf die Möglichkeit
              auswirken, Schaden&shy;ersatz&shy;ansprüche wegen einer Verletzung der Beratungs- und Dokumen&shy;tations&shy;pflichten (§ 6 Abs. 5 VVG) gegen uns geltend zu machen.
            </p>
          </If>
          <h4>Information zur Verwendung Ihrer Daten</h4>

          <p className="text--small">
            Wir nutzen Ihre Daten ausschließlich im Rahmen unserer Datenschutzhinweise und unseres Datenschutzkodex –
            unter anderem zur Angebotserstellung und Durchführung Ihres Vertrages oder – in Einzelfällen – für Anfragen bei
            Ihrem Vorversicherer. Außerdem informieren wir Sie gelegentlich zu unseren Produkten per Post.
            Dieser Nutzung Ihrer Daten können Sie jederzeit per E-Mail an
            {' '}
            {i18next.t('anschrift.email')}
            {' '}
            widersprechen.
          </p>
          <If predicate={!trEnv.stationaer}>
            <p className="text--small">
              Sie haben die Information zur Verwendung Ihrer Daten auf der vorhergehenden Seite zur
              Kenntnis genommen.
            </p>
          </If>
          <h4>Folgenden Verhaltenskodizes haben wir uns als Versicherer unterworfen</h4>
          <div className="text--small">
            <ul className="list-icn-square">
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  data-tracking-name="link-verhaltensregeln"
                  href={i18next.t('datenschutz.datenschutzkodex')}
                >
                  Verhaltensregeln für den Umgang mit personenbezogenen Daten durch die deutsche
                  Versicherungswirtschaft
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  data-tracking-name="link-verhaltenskodex"
                  href={i18next.t('datenschutz.verhaltenskodex')}
                >
                  Verhaltenskodex des Gesamtverbandes der Deutschen Versicherungswirtschaft für den
                  Vertrieb von Versicherungsprodukten
                </a>
              </li>
            </ul>
          </div>
        </div>
      ),
    },
  ];
};

export default Versicherungspaket;
